// @flow

import React from "react";
import { View, Text } from "@components";

type Props = {
  title: string,
  formStyle?: boolean,
  description: string,
  children: React.ReactNode,
};

export const BoxField = ({ title, description, formStyle, children }: Props) => {
  return (
    <View direction="row" justifyContent="space-between" alignItems="center" gap={4}>
      <View flex={formStyle ? 2 : null}>
        <Text type="strong">{title}</Text>
        <Text className={"gs-text-sec-text-color fs-12"}>{description}</Text>
      </View>
      <View justifyContent="space-between" flex={formStyle ? 1 : null}>
        <View justifyContent="space-between" alignItems="end">
          {children}
        </View>
      </View>
    </View>
  );
};
